// extracted by mini-css-extract-plugin
export default {"photo":"FeedPhotosItem_photo__0y7P0","view":"FeedPhotosItem_view__6kTxc"};